import React, { useMemo, useState } from "react";
import { Box } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import CommonTableHead from "../../../../../common/CommonTableHead";
import TablePaginationSection from "../../../../../common/TablePaginationSection";
import { getComparator, stableSort } from "../../../../../constants";
import { GroupsTableRow } from "../components";

const headCells = [
  { id: "name", numeric: false, disablePadding: true, label: "Group Name", width: 260 },
  { id: "id", numeric: false, disablePadding: true, label: "Group ID", width: 220 },
  { id: "createdBy", numeric: false, disablePadding: true, label: "Created By", width: 220 },
  { id: "createdAt", numeric: false, disablePadding: true, label: "Creation Date", width: 200 },
  { id: "members", numeric: false, disablePadding: true, label: "# Members", width: 140 },
  { id: "quicktales", numeric: false, disablePadding: true, label: "# QuickTales", width: 140 },
  { id: "status", numeric: false, disablePadding: true, label: "Status", width: 140 },
];

export default function GroupsTable({ selected, setSelected, groups, onRowClick }) {
  const [order, setOrder] = useState("desc");
  const [orderBy, setOrderBy] = useState("createdAt");
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(25);

  const visibleRows = useMemo(
    () =>
      stableSort(groups || [], getComparator(order, orderBy)).slice(
        (page - 1) * rowsPerPage,
        (page - 1) * rowsPerPage + rowsPerPage
      ),
    [groups, order, orderBy, page, rowsPerPage]
  );

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = visibleRows.map((n) => n.id);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };

  const handleClickRow = (event, id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
  };

  return (
    <Paper sx={{ width: "100%", mb: 1, border: "none", boxShadow: "none", mt: 1 }}>
      <TableContainer style={{ border: "none", boxShadow: "none", maxHeight: "calc(90vh - 180px)", maxWidth: "calc(90vw - 120px)" }}>
        <Table stickyHeader>
          <CommonTableHead
            numSelected={selected.length}
            order={order}
            orderBy={orderBy}
            onSelectAllClick={handleSelectAllClick}
            rowCount={visibleRows.length}
            onRequestSort={handleRequestSort}
            tableHeadCells={headCells}
            showPosition={false}
            columnWidths={{}}
            onColumnResize={() => {}}
          />
          <TableBody>
            {visibleRows.map((row, index) => (
              <GroupsTableRow
                key={row.id}
                row={row}
                isItemSelected={selected.indexOf(row.id) !== -1}
                labelId={`ga-groups-checkbox-${index}`}
                handleClickRow={handleClickRow}
                onRowClick={onRowClick}
                numberType={index % 2 === 0}
              />
            ))}

            {visibleRows.length === 0 && (
              <TableRow>
                <TableCell colSpan={9} align="center">
                  No results found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <Box>
        <TablePaginationSection
          count={groups && Math.ceil(groups.length / rowsPerPage)}
          page={page}
          onPageChange={(e, p) => setPage(p)}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={(e) => {
            setRowsPerPage(parseInt(e.target.value, 10));
            setPage(1);
          }}
          total={groups?.length ?? 0}
        />
      </Box>
    </Paper>
  );
}

